export default '/auth'



// WEBPACK FOOTER //
// ./src/api/auth.js